import { FinderBase } from './FinderBase';
import { MultiSelectDescriptor } from './MultiSelectDescriptor';
import { RangeDescriptor } from './RangeDescriptor';
import { StringDescriptor } from './StringDescriptor';

export class FinderGruppoLavorazioniPerStagione extends FinderBase
{
    public stagione: string = "";
    public idFornitore: string = "";
    public filtroStagione?: MultiSelectDescriptor;
}

export class FinderGruppoLavorazioniPerFase extends FinderBase
{
    public fase: string = "";
    public idFornitore: string = "";
    public filtroFase?: MultiSelectDescriptor;
    public filtroStagione?: MultiSelectDescriptor;
    public filtroCapiLanciati?: RangeDescriptor<number>;
}

export class FinderGruppoLavorazioniPerConsegna extends FinderBase
{
    public consegna: string = "";
    public idFornitore: string = "";
    public filtroStagione?: MultiSelectDescriptor;
    public filtroConsegna?: MultiSelectDescriptor;
}

export class FinderGruppoLavorazioniPerLotto extends FinderBase
{
    public lotto: string = "";
    public idFornitore: string = "";
    public filtroStagione?: MultiSelectDescriptor;
    public filtroLotto?: MultiSelectDescriptor;
}